import { useState, useEffect } from "react";
import { TextField, Button, MenuItem, InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import SearchIcon from "@mui/icons-material/Search";
import ActionButtons from "../components/common/ActionButtons";

import {
    addDailyService,
    updateDailyService,
    deleteDailyService,
    getDailyServices
} from "../services/dailyServiceService";
import { getEmployees } from "../services/employeeService";
import { getCustomers } from "../services/customerService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import usePagination from "../hooks/usePagination";
import PaginationControls from "../components/common/PaginationControls";
import DateCell from "../components/common/DateCell";

function DailyService() {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    const userRole =
        (loggedInUser?.role || "").toLowerCase();

    //const loggedEmployeeId =
    //    loggedInUser?.empId || "";

    //const loggedBranchId =
    //    loggedInUser?.branchId || "";

    const loggedEmployeeId =
        Number(loggedInUser?.empId || 0);

    const loggedBranchId =
        Number(loggedInUser?.branchId || 0);

    const allBranches =
        (loggedInUser?.allBranches || "N") === "Y";

    const branchManager =
        (loggedInUser?.branchManager || "N") === "Y";

    const isAdmin =
        userRole === "admin";

    const isManager =
        userRole === "manager";

    const isUser =
        userRole === "user";

    const [form, setForm] = useState({
        employeeId: "",
        employeeName: "",
        employeeLocation: "",
        organizationName: "",
        customerName: "",
        contactNumber: "",
        emailAddress: "",
        customerType: "",

        serviceType: "",
        machineModel: "",
        serviceCharges: "",   // ✅ ADDED HERE
        serialNumber: "",
        complaint: "",
        actionTaken: "",
        spareUsed: "",
        serviceStatus: "Pending",
        visitDate: "",

        remarks: "",
        status: "Active"
    });

    const [employees, setEmployees] = useState([]);
    const loggedEmployeeName =
        employees.find(
            e => e.id === loggedEmployeeId
        )?.empName || "";
    const [customers, setCustomers] = useState([]);

    // ✅ MAIN DATA
    const [callLogs, setCallLogs] = useState([]);

    // ✅ FILTER STATES (KEEP ONLY THESE)
    const [showInactive, setShowInactive] = useState(false);
    const [searchText, setSearchText] = useState("");
    const today = new Date();

    const sevenDaysAgo = new Date();

    sevenDaysAgo.setDate(today.getDate() - 7);

    const [fromDate, setFromDate] = useState(
        sevenDaysAgo.toISOString().split("T")[0]
    );

    const [toDate, setToDate] = useState(
        today.toISOString().split("T")[0]
    );
    const [sortField, setSortField] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDirection("asc");
        }
    };

    const handleLast7Days = () => {

        const today = new Date();

        const sevenDaysAgo = new Date();

        sevenDaysAgo.setDate(today.getDate() - 7);

        setFromDate(
            sevenDaysAgo.toISOString().split("T")[0]
        );

        setToDate(
            today.toISOString().split("T")[0]
        );
    };

    // ✅ ALL STATES FIRST
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const highlightText = (text) => {

        if (!searchText) return text;

        const regex = new RegExp(`(${searchText})`, "gi");

        const parts = String(text || "").split(regex);

        return parts.map((part, index) =>

            part.toLowerCase() === searchText.toLowerCase()

                ? (
                    <span
                        key={index}
                        style={{
                            backgroundColor: "yellow",
                            fontWeight: "bold"
                        }}
                    >
                        {part}
                    </span>
                )

                : part
        );
    };

    // ✅ FILTER LOGIC
    const filteredData = (callLogs || [])
    .filter(c => {

        // ADMIN + AllBranches=Y
        if (isAdmin && allBranches) {
            return true;
        }

        // ADMIN + AllBranches=N
        if (isAdmin && !allBranches) {

            return employees.some(
                e =>
                    (e.empName || "").trim().toLowerCase() ===
                    (c.employeeName || "").trim().toLowerCase()
                    &&
                    e.branchId === loggedBranchId
            );
        }

        // MANAGER + BranchManager=Y
        if (isManager && branchManager) {

            return employees.some(
                e =>
                    (e.empName || "").trim().toLowerCase() ===
                    (c.employeeName || "").trim().toLowerCase()
                    &&
                    e.branchId === loggedBranchId
            );
        }

        // MANAGER + BranchManager=N
        if (isManager && !branchManager) {

            return (
                (c.employeeName || "").trim().toLowerCase() ===
                (loggedEmployeeName || "").trim().toLowerCase()
            );
        }

        // USER
        if (isUser) {

            return (
                (c.employeeName || "").trim().toLowerCase() ===
                (loggedEmployeeName || "").trim().toLowerCase()
            );
        }

        return false;
    })

    // SEARCH FILTER
    // DATE FILTER
    .filter(c => {

        if (!c.createdOn) return false;

        const createdDate =
            new Date(c.createdOn)
                .toISOString()
                .split("T")[0];

        return (
            createdDate >= fromDate &&
            createdDate <= toDate
        );
    })

    
    // SEARCH FILTER
    .filter(c => {

        const search = searchText.toLowerCase();

        return (

            (c.employeeName || "").toLowerCase().includes(search) ||

            (c.organizationName || "").toLowerCase().includes(search) ||

            (c.customerName || "").toLowerCase().includes(search) ||

            (c.contactNumber || "").toLowerCase().includes(search) ||

            (c.serviceType || "").toLowerCase().includes(search) ||

            (c.machineModel || "").toLowerCase().includes(search) ||

            (c.serialNumber || "").toLowerCase().includes(search) ||

            (c.complaint || "").toLowerCase().includes(search) ||

            (c.actionTaken || "").toLowerCase().includes(search) ||

            (c.spareUsed || "").toLowerCase().includes(search) ||

            (c.serviceStatus || "").toLowerCase().includes(search) ||

            (c.status || "").toLowerCase().includes(search) ||

            String(c.serviceCharges || "")
                .toLowerCase()
                .includes(search) ||

            (c.visitDate
                ? new Date(c.visitDate)
                    .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    })
                    .toLowerCase()
                    .includes(search)
                : false)
        );
    })

    .sort((a, b) => {
        if (!sortField) return 0;

        let valA = a[sortField] || "";
        let valB = b[sortField] || "";

        if (typeof valA === "string") valA = valA.toLowerCase();
        if (typeof valB === "string") valB = valB.toLowerCase();

        if (valA < valB) return sortDirection === "asc" ? -1 : 1;
        if (valA > valB) return sortDirection === "asc" ? 1 : -1;
        return 0;
    })

    // 🔹 Load once (initial)
    useEffect(() => {
        loadEmployees();
        loadCustomers();
        loadDailyServices();   // ✅ ADD THIS LINE
    }, []);

    useEffect(() => {

        // USER ROLE
        if (userRole === "user") {

            setForm(prev => ({
                ...prev,
                employeeId: loggedEmployeeId,
                employeeName: loggedEmployeeName
            }));
        }

    }, [userRole, loggedEmployeeId, loggedEmployeeName]);

    // 🔹 Reload when checkbox changes
    useEffect(() => {
        loadDailyServices();
    }, [showInactive]);

    const {
        page,
        setPage,
        totalPages,
        paginatedData
    } = usePagination(filteredData, rowsPerPage);

    useEffect(() => {
        setPage(0);
    }, [searchText, showInactive, rowsPerPage]);

    const loadEmployees = async () => {

        try {

            const res = await getEmployees();

            let data = res.data || [];

            // ADMIN + AllBranches=Y
            if (isAdmin && allBranches) {

                // show all employees
            }

            // ADMIN + AllBranches=N
            else if (isAdmin && !allBranches) {

                data = data.filter(
                    e => e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=Y
            else if (isManager && branchManager) {

                data = data.filter(
                    e => e.branchId === loggedBranchId
                );
            }

            // MANAGER + BranchManager=N
            else if (isManager && !branchManager) {

                data = data.filter(
                    e => e.id === loggedEmployeeId
                );
            }

            // USER
            else if (isUser) {

                data = data.filter(
                    e => e.id === loggedEmployeeId
                );
            }

            setEmployees(data);

        } catch (err) {

            console.error("Failed to load employees", err);
        }
    };

    const loadCustomers = async () => {
        try {
            const res = await getCustomers();
            setCustomers(res.data);
        } catch (err) {
            console.error("Failed to load customers", err);
        }
    };

    const loadDailyServices = async () => {
        try {
            const res = await getDailyServices(showInactive); // ✅ pass checkbox value
            setCallLogs(res.data);
        } catch (err) {
            console.error("Failed to load data", err);
        }
    };
    const [isEdit, setIsEdit] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value   // 🔥 REMOVE null conversion
        }));
    };

    // 🔥 NEW FUNCTION (IMPORTANT)
    const handleEmployeeChange = (e) => {
        const empId = e.target.value;

        const selectedEmp = employees.find(emp => emp.id === Number(empId));

        setForm(prev => ({
            ...prev,
            employeeId: empId,
            employeeLocation: selectedEmp?.location || "",
            employeeName: selectedEmp?.empName || ""
        }));
    };

    const handleCustomerChange = (e) => {
        const id = e.target.value;

        const selected = customers.find(c => c.id === id);

        if (!selected) return;

        setForm(prev => ({
            ...prev,
            customerId: id,
            organizationName: selected.organizationName,
            customerName: selected.customerName,
            contactNumber: selected.contactNumber,
            emailAddress: selected.emailAddress,
            customerType: selected.customerType
        }));
    };

    const handleOrganizationChange = (e) => {
        const value = e.target.value;

        // 🔍 exact match only (NOT startsWith)
        const exactMatch = customers.find(c =>
            (c.organizationName || "").toLowerCase().trim() === value.toLowerCase().trim()
        );

        if (exactMatch) {
            // ✅ AUTO-FILL ONLY WHEN EXACT MATCH
            setForm(prev => ({
                ...prev,
                organizationName: value,
                customerName: exactMatch.customerName || "",
                contactNumber: exactMatch.contactNumber || "",
                emailAddress: exactMatch.emailAddress || "",
                customerType: exactMatch.customerType || ""
            }));
        } else {
            // ✅ USER IS TYPING / EDITING → DO NOT OVERRIDE
            setForm(prev => ({
                ...prev,
                organizationName: value,
                customerName: "",
                contactNumber: "",
                emailAddress: "",
                customerType: ""
            }));
        }
    };
    const handleSave = async () => {
        try {
            console.log("SAVE CLICKED");

            const payload = {
                employeeId: form.employeeId ? Number(form.employeeId) : null,
                employeeName: form.employeeName,
                customerName: form.customerName,
                organizationName: form.organizationName,
                contactNumber: form.contactNumber,
                emailAddress: form.emailAddress || null,
                location: form.employeeLocation,
                customerType: form.customerType,

                serviceType: form.serviceType,
                machineModel: form.machineModel,
                serviceCharges: form.serviceCharges ? Number(form.serviceCharges) : 0,
                serialNumber: form.serialNumber,
                complaint: form.complaint,
                actionTaken: form.actionTaken,
                spareUsed: form.spareUsed,
                serviceStatus: form.serviceStatus,
                visitDate: form.visitDate || null,

                remarks: form.remarks,
                status: form.status
            };

            let res;

            if (form.id) {
                // ✅ UPDATE
                res = await updateDailyService(form.id, {
                    ...payload,
                    id: form.id
                });
            } else {
                // ✅ CREATE
                res = await addDailyService(payload);
            }

            alert(form.id ? "Updated successfully" : "Saved successfully");

            loadDailyServices();

            setForm({
                employeeId: "",
                employeeName: "",
                employeeLocation: "",
                organizationName: "",
                customerName: "",
                contactNumber: "",
                emailAddress: "",
                customerType: "",

                serviceType: "",
                machineModel: "",
                serialNumber: "",
                complaint: "",
                actionTaken: "",
                spareUsed: "",
                serviceStatus: "Pending",
                visitDate: "",

                remarks: "",
                status: "Active"
            });

            setIsEdit(false);

        } catch (err) {
            console.error("ERROR:", err);
            alert(err.response?.data || "Error saving data");
        }
    };

    const handleEdit = (row) => {
        const selectedEmp = employees.find(
            e => e.empName === row.employeeName
        );

        setForm({
            id: row.id,
            employeeId: selectedEmp?.id || "",
            employeeName: selectedEmp?.empName || row.employeeName || "",
            employeeLocation: row.location || "",
            organizationName: row.organizationName || "",
            customerName: row.customerName || "",
            contactNumber: row.contactNumber || "",
            emailAddress: row.emailAddress || "",
            customerType: row.customerType || "",

            serviceType: row.serviceType || "",
            machineModel: row.machineModel || "",
            serviceCharges: row.serviceCharges || "",
            serialNumber: row.serialNumber || "",
            complaint: row.complaint || "",
            actionTaken: row.actionTaken || "",
            spareUsed: row.spareUsed || "",
            serviceStatus: row.serviceStatus || "Pending",
            visitDate: row.visitDate ? row.visitDate.split("T")[0] : "",

            remarks: row.remarks || "",
            status: row.status || "Active"
        });

        setIsEdit(true);
    };

    const handleDelete = async (row) => {
        if (!window.confirm("Deactivate this record?")) return;

        if (!row.id) {
            alert("Invalid record id");
            return;
        }

        try {
            const payload = {
                id: row.id,
                employeeName: row.employeeName,
                customerName: row.customerName,
                organizationName: row.organizationName,
                contactNumber: row.contactNumber,
                emailAddress: row.emailAddress,
                location: row.location,
                customerType: row.customerType,

                serviceType: row.serviceType,
                machineModel: row.machineModel,
                serviceCharges: row.serviceCharges,
                serialNumber: row.serialNumber,
                complaint: row.complaint,
                actionTaken: row.actionTaken,
                spareUsed: row.spareUsed,
                serviceStatus: row.serviceStatus,
                visitDate: row.visitDate ? row.visitDate.split("T")[0] : null,

                remarks: row.remarks,
                status: "Inactive"
            };

            await updateDailyService(row.id, payload);

            console.log("DELETE ROW:", row);

            loadDailyServices();

        } catch (err) {
            console.error("Delete failed:", err);
            alert("Error deleting record");
        }
    };

    const handlePermanentDelete = async (row) => {
        if (!window.confirm("Delete permanently?")) return;

        if (!row.id) {
            alert("Invalid record id");
            return;
        }

        try {
            await deleteDailyService(row.id);

            console.log("PERMANENT DELETE:", row);

            loadDailyServices();

        } catch (err) {
            console.error("Permanent delete failed:", err);
            alert("Error deleting permanently");
        }
    };

    const handleRestore = async (row) => {
        if (!window.confirm("Restore this record?")) return;

        if (!row.id) {
            alert("Invalid record id");
            return;
        }

        try {
            const payload = {
                id: row.id,
                employeeName: row.employeeName,
                customerName: row.customerName,
                organizationName: row.organizationName,
                contactNumber: row.contactNumber,
                emailAddress: row.emailAddress,
                location: row.location,
                customerType: row.customerType,

                serviceType: row.serviceType,
                machineModel: row.machineModel,
                serviceCharges: row.serviceCharges,
                serialNumber: row.serialNumber,
                complaint: row.complaint,
                actionTaken: row.actionTaken,
                spareUsed: row.spareUsed,
                serviceStatus: row.serviceStatus,
                visitDate: row.visitDate ? row.visitDate.split("T")[0] : null,

                remarks: row.remarks,
                status: "Active"
            };

            await updateDailyService(row.id, payload);

            alert("Restored successfully");

            console.log("RESTORE:", row);

            loadDailyServices();

        } catch (err) {
            console.error("Restore error:", err);
            alert("Error restoring record");
        }
    };

    const handleCancel = () => {
        setForm({
            id: "",   // ✅ added

            employeeId: "",
            employeeName: "",
            employeeLocation: "",
            organizationName: "",
            customerName: "",
            contactNumber: "",
            emailAddress: "",
            customerType: "",

            serviceType: "",
            machineModel: "",
            serviceCharges: "",
            serialNumber: "",
            complaint: "",
            actionTaken: "",
            spareUsed: "",
            serviceStatus: "Pending",
            visitDate: "",

            remarks: "",
            status: "Active"
        });

        setIsEdit(false);

        window.scrollTo({ top: 0, behavior: "smooth" }); // ✅ optional
    };

    const handleExport = () => {
        try {
            if (!callLogs || callLogs.length === 0) {
                alert("No data to export");
                return;
            }

            const data = (callLogs || []).map(c => ({
                Id: c.id,
                EmployeeName: c.employeeName,
                CustomerName: c.customerName,
                OrganizationName: c.organizationName,
                ContactNumber: c.contactNumber,
                EmailAddress: c.emailAddress,
                Location: c.location,
                CustomerType: c.customerType,

                // ✅ SERVICE FIELDS
                ServiceType: c.serviceType,
                MachineModel: c.machineModel,
                ServiceCharges: c.serviceCharges,
                SerialNumber: c.serialNumber,
                Complaint: c.complaint,
                ActionTaken: c.actionTaken,
                SpareUsed: c.spareUsed,
                ServiceStatus: c.serviceStatus,
                VisitDate: c.visitDate ? c.visitDate.split("T")[0] : "",

                Remarks: c.remarks,
                CreatedOn: c.createdOn ? c.createdOn.split("T")[0] : "",
                UpdatedOn: c.updatedOn ? c.updatedOn.split("T")[0] : "",
                Status: c.status
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "DailyService");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            saveAs(blob, "DailyService_Data.xlsx");

        } catch (err) {
            console.error("Export error:", err);
            alert("Error exporting Excel");
        }
    };

    return (
        <div style={styles.container}>

            <div style={styles.header}>
                <h2>Daily Service Entry</h2>
            </div>

            <div style={styles.card}>
                <div style={styles.formContainer}>

                    {/* ROW 1 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                select
                                label="Employee"
                                name="employeeId"
                                disabled={userRole === "user"}
                                value={form.employeeId}
                                onChange={handleEmployeeChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            >
                                {[...employees]

                                    .sort((a, b) =>
                                        a.empName.localeCompare(b.empName)
                                    )

                                    .map(emp => (

                                        <MenuItem
                                            key={emp.id}
                                            value={emp.id}
                                            sx={{
                                                fontFamily: "Verdana",
                                                fontSize: "12px"
                                            }}
                                        >
                                            <div style={{
                                                display: "flex",
                                                width: "100%",
                                                alignItems: "center"
                                            }}>

                                                {/* EMPLOYEE */}
                                                <span style={{
                                                    width: "160px",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis"
                                                }}>
                                                    {emp.empName}
                                                </span>

                                                {/* BRANCH */}
                                                <span style={{
                                                    width: "140px"
                                                }}>
                                                    {"-> "} {emp.branchName}
                                                </span>

                                                {/* MOBILE */}
                                                <span>
                                                    {"-> "} {emp.mobileNo}
                                                </span>

                                            </div>
                                        </MenuItem>

                                    ))}
                            </TextField>
                        </div>

                        <div style={{ width: "50%" }}>
                            {/*<TextField*/}
                            {/*    label="Employee Location"*/}
                            {/*    name="employeeLocation"*/}
                            {/*    value={form.employeeLocation}*/}
                            {/*    fullWidth*/}
                            {/*    size="small"*/}
                            {/*    sx={styles.inputStyle}*/}
                            {/*    InputProps={{ readOnly: true }}*/}
                            {/*/>*/}
                            <TextField
                                label="Location"   // 🔥 changed label
                                name="employeeLocation"
                                value={form.employeeLocation}
                                onChange={handleChange}   // 🔥 allow typing
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            />
                        </div>
                    </div>

                    {/* ROW 2 */}
                    {/* ROW 2 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Organization Name"
                                name="organizationName"
                                value={form.organizationName}
                                onChange={handleOrganizationChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                inputProps={{ list: "org-list" }}   // 🔥 enables dropdown + typing
                            />

                            <datalist id="org-list">
                                {customers.map(c => (
                                    <option key={c.id} value={c.organizationName} />
                                ))}
                            </datalist>
                        </div>

                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Customer Name"
                                name="customerName"
                                value={form.customerName}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            />
                        </div>
                    </div>

                    {/* ROW 3 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Contact Number"
                                name="contactNumber"
                                value={form.contactNumber}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}   // 🔥 FIX
                            />
                        </div>

                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Email Address"
                                name="emailAddress"
                                value={form.emailAddress || ""}   // ✅ IMPORTANT
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}   // 🔥 FIX
                            />
                        </div>
                    </div>

                    {/* ROW 4 */}
                    <div style={styles.row}>

                        <div style={{ width: "25%" }}>
                            <TextField
                                select
                                label="Customer Type"
                                name="customerType"
                                value={form.customerType || ""}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                "& .MuiMenuItem-root": {
                                                    fontSize: "12px",
                                                    fontFamily: "Verdana"
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="Banking">Banking</MenuItem>
                                <MenuItem value="Non Banking">Non Banking</MenuItem>
                                <MenuItem value="Institutional">Institutional</MenuItem>
                            </TextField>
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                select
                                label="Service Type"
                                name="serviceType"
                                value={form.serviceType}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                "& .MuiMenuItem-root": {
                                                    fontSize: "12px",
                                                    fontFamily: "Verdana"
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="Installation">Installation</MenuItem>
                                <MenuItem value="Breakdown">Breakdown</MenuItem>
                                <MenuItem value="AMC">AMC</MenuItem>
                                <MenuItem value="General">General Service</MenuItem>

                                <MenuItem value="Locker Break Open">Locker Break Open</MenuItem>
                                <MenuItem value="SRD Service">SRD Service</MenuItem>
                                <MenuItem value="SRD Locks Change">SRD Locks Change</MenuItem>
                                <MenuItem value="Safe Service">Safe Service</MenuItem>
                                <MenuItem value="Safe Locks Change">Safe Locks Change</MenuItem>
                                <MenuItem value="Lever Change">Lever Change</MenuItem>
                                <MenuItem value="Inter Change">Inter Change</MenuItem>
                                <MenuItem value="Key Embossing">Key Embossing</MenuItem>
                                <MenuItem value="Grill Gate Service">Grill Gate Service</MenuItem>
                                <MenuItem value="Grill Gate Locks Changing">Grill Gate Locks Changing</MenuItem>
                                <MenuItem value="FRRC Repair">FRRC Repair</MenuItem>
                                <MenuItem value="FRRC Locks Change">FRRC Locks Change</MenuItem>
                                <MenuItem value="Cellular Cabinet Service">Cellular Cabinet Service</MenuItem>
                                <MenuItem value="Bin Service">Bin Service</MenuItem>
                                <MenuItem value="Biometric Service">Biometric Service</MenuItem>
                                <MenuItem value="Racks Service">Racks Service</MenuItem>
                                <MenuItem value="Almirah Service">Almirah Service</MenuItem>                            </TextField>
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                label="Visit Date"
                                name="visitDate"
                                type="date"
                                value={form.visitDate}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                select
                                label="Service Status"
                                name="serviceStatus"
                                value={form.serviceStatus}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                "& .MuiMenuItem-root": {
                                                    fontSize: "12px",
                                                    fontFamily: "Verdana"
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                                <MenuItem value="Hold">Hold</MenuItem>
                            </TextField>
                        </div>

                    </div>
                    <div style={styles.row}>

                        <div style={{ width: "25%" }}>
                            <TextField
                                label="Machine Model"
                                name="machineModel"
                                value={form.machineModel}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            />
                        </div>

                        <div style={{ width: "25%" }}>
                            <TextField
                                label="Service Charges"
                                name="serviceCharges"
                                type="number"
                                value={form.serviceCharges || ""}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                inputProps={{ step: "0.01", min: "0" }}
                            />
                        </div>

                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Serial Number"
                                name="serialNumber"
                                value={form.serialNumber}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                            />
                        </div>

                    </div>

                    {/* ROW 5 */}
                    <div style={styles.row}>
                        <div style={{ width: "50%" }}>
                            <TextField
                                label="Complaint"
                                name="complaint"
                                value={form.complaint}
                                onChange={handleChange}
                                fullWidth
                                multiline
                                size="small"
                                rows={6}
                                sx={{
                                    ...styles.inputStyle,
                                    "& .MuiInputBase-root": {
                                        height: "100px",
                                        alignItems: "flex-start"
                                    }
                                }}
                            />
                        </div>

                        {/* RIGHT SIDE */}
                        <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: "8px" }}>

                            {/* REMARKS */}
                            <TextField
                                label="Remarks"
                                name="remarks"
                                value={form.remarks}
                                onChange={handleChange}
                                fullWidth
                                multiline
                                size="small"
                                rows={4}
                                sx={{
                                    ...styles.inputStyle,   // ✅ keep font
                                    "& .MuiInputBase-root": {
                                        height: "60px",     // ✅ keep height
                                        alignItems: "flex-start"
                                    }
                                }}
                            />

                            {/* STATUS */}
                            <TextField
                                select
                                label="Status"
                                name="status"
                                value={form.status || ""}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                sx={styles.inputStyle}
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                "& .MuiMenuItem-root": {
                                                    fontSize: "12px",
                                                    fontFamily: "Verdana"
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Closed">Closed</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                            </TextField>

                        </div>
                    </div>

                </div>

                <div style={styles.buttonRow}>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            //minWidth: "100px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            textTransform: "none"
                        }}
                    >
                        {isEdit ? "Update" : "Save"}
                    </Button>

                    {isEdit && (
                        <Button
                            variant="contained"
                            onClick={handleCancel}
                            sx={{
                                height: "28px",
                                //minWidth: "100px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                padding: "0 12px",
                                textTransform: "none",
                                backgroundColor: "#3a3f45",   // 🔥 dark grey like your pic
                                marginLeft: "10px",
                                "&:hover": {
                                    backgroundColor: "#2f343a"
                                }
                            }}
                        >
                            Cancel
                        </Button>
                    )}
                </div>

            </div>   {/* ✅ FORM CARD ENDS HERE */}


            {/* 🔥 🔥 PASTE TABLE HERE 🔥 🔥 */}
            <div style={styles.card}>

                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "15px",
                    width: "100%",
                    flexWrap: "wrap"
                }}>
                    {/* ✅ ADD THIS FIRST */}
                    {/* LAST 7 DAYS */}
                    <Button
                        variant="contained"
                        onClick={handleLast7Days}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            textTransform: "none",
                            background: "#57606f"
                        }}
                    >
                        Last 7 Days
                    </Button>

                    {/* DATE FILTERS */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>

                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            style={{
                                height: "28px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 10px",
                                boxSizing: "border-box"
                            }}
                        />

                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            style={{
                                height: "28px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 10px",
                                boxSizing: "border-box"
                            }}
                        />

                        <Button
                            variant="contained"
                            sx={{
                                height: "30px",
                                minHeight: "30px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                padding: "0 12px",
                                textTransform: "none",
                                background: "#2f3542",

                                "&:hover": {
                                    background: "#3a3f45"
                                }
                            }}
                        >
                            Filter
                        </Button>

                    </div>
                    <label style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
                        <input
                            type="checkbox"
                            checked={showInactive}
                            onChange={(e) => setShowInactive(e.target.checked)}
                        />
                        Show Inactive
                    </label>
                    {/* 🔍 Search Box (FIXED) */}
                    <TextField
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        size="small"
                        sx={{
                            width: "220px",

                            "& .MuiOutlinedInput-root": {
                                height: "28px",
                                fontFamily: "Verdana"
                            },

                            "& .MuiOutlinedInput-input": {
                                padding: "4px 10px",
                                fontSize: "12px",
                                fontFamily: "Verdana"
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                            endAdornment: searchText && (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        onClick={() => setSearchText("")}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    {/* 📤 Export */}
                    <Button
                        variant="contained"
                        onClick={handleExport}
                        sx={{
                            height: "28px",
                            minHeight: "28px",
                            fontSize: "12px",
                            fontFamily: "Verdana",
                            padding: "0 12px",
                            background: "#3742fa"
                        }}
                    >
                        Export
                    </Button>

                    {/* 📄 Rows */}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <span style={{ fontSize: "12px" }}>Rows</span>
                        <select
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(parseInt(e.target.value))}
                            style={{
                                height: "28px",
                                fontSize: "12px",
                                fontFamily: "Verdana",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "0 5px"
                            }}
                        >
                            {[5, 10, 20, 30, 50].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                    </div>

                </div>

                <div style={{ ...styles.tableWrapper, marginTop: "10px" }}>
                    <table style={styles.table}>
                        <thead style={styles.tableHeader}>
                            <tr>

                                {/* EMPLOYEE */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("employeeName")}>
                                    Employee{" "}
                                    {sortField === "employeeName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ORGANIZATION */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("organizationName")}>
                                    Organization{" "}
                                    {sortField === "organizationName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* CUSTOMER */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("customerName")}>
                                    Customer{" "}
                                    {sortField === "customerName"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* CONTACT */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("contactNumber")}>
                                    Contact{" "}
                                    {sortField === "contactNumber"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ✅ SERVICE TYPE (FIXED) */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("serviceType")}>
                                    Service Type{" "}
                                    {sortField === "serviceType"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ✅ SERVICE CHARGES (ADDED PROPERLY) */}
                                <th
                                    style={{ ...styles.th, cursor: "pointer", textAlign: "right", whiteSpace: "nowrap" }}
                                    onClick={() => handleSort("serviceCharges")}
                                >
                                    Service Chr{" "}
                                    {sortField === "serviceCharges"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                <th
                                    style={{ ...styles.th, cursor: "pointer", whiteSpace: "nowrap" }}
                                    onClick={() => handleSort("createdOn")}
                                >
                                    Created On{" "}
                                    {sortField === "createdOn"
                                        ? (sortDirection === "asc" ? "↑" : "↓")
                                        : "↕"}
                                </th>
                                <th
                                    style={{ ...styles.th, cursor: "pointer", whiteSpace: "nowrap" }}
                                    onClick={() => handleSort("updatedOn")}
                                >
                                    Updated On{" "}
                                    {sortField === "updatedOn"
                                        ? (sortDirection === "asc" ? "↑" : "↓")
                                        : "↕"}
                                </th>

                                {/* STATUS */}
                                <th style={{ ...styles.th, cursor: "pointer" }} onClick={() => handleSort("status")}>
                                    Status{" "}
                                    {sortField === "status"
                                        ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                                </th>

                                {/* ACTIONS */}
                                <th style={styles.th}>Actions</th>

                            </tr>
                        </thead>

                        <tbody>
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "10px" }}>
                                        No records found
                                    </td>
                                </tr>
                            ) : (
                                paginatedData.map((c) => (
                                    <tr key={c.id}>

                                        <td style={styles.td}>
                                            {highlightText(c.employeeName)}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(c.organizationName)}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(c.customerName)}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(c.contactNumber)}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(c.serviceType)}
                                        </td>

                                        {/* ✅ SERVICE CHARGES */}
                                        <td style={{ ...styles.td, textAlign: "right" }}>
                                            {highlightText(
                                                c.serviceCharges ? `₹ ${c.serviceCharges}` : ""
                                            )}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(
                                                c.createdOn
                                                    ? new Date(c.createdOn).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric"
                                                    })
                                                    : ""
                                            )}
                                        </td>

                                        <td style={styles.td}>
                                            {highlightText(
                                                c.updatedOn
                                                    ? new Date(c.updatedOn).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric"
                                                    })
                                                    : ""
                                            )}
                                        </td>

                                        <td style={{ ...styles.td, textAlign: "center" }}>
                                            <span
                                                style={{
                                                    fontWeight: "bold",
                                                    padding: "2px 8px",
                                                    borderRadius: "10px",
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    backgroundColor:
                                                        c.status === "Active" ? "#28a745" :
                                                            c.status === "Pending" ? "#ff9800" :
                                                                c.status === "Closed" ? "#6c757d" :
                                                                    c.status === "Inactive" ? "#dc3545" :
                                                                        "#999"
                                                }}
                                            >
                                                {highlightText(c.status || "Active")}
                                            </span>
                                        </td>

                                        <td style={{ ...styles.td, textAlign: "center" }}>
                                            <ActionButtons
                                                row={c}
                                                status={c.status}
                                                onEdit={handleEdit}
                                                onDelete={handleDelete}
                                                onPermanentDelete={handlePermanentDelete}
                                                onRestore={() => handleRestore(c)}
                                                canEdit={true}
                                                canDelete={true}
                                            />
                                        </td>

                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {/* 🔥 ADD THIS BLOCK RIGHT HERE */}
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "10px",
                    gap: "10px",
                    fontSize: "12px",
                    fontFamily: "Verdana"
                }}>

                    <PaginationControls
                        page={page}
                        setPage={setPage}
                        totalPages={totalPages}
                    />

                </div>
            </div>
        </div>

    );
}

const styles = {
    container: {
        padding: "5px",
        background: "#f1f2f6",
        fontFamily: "Verdana",
        fontSize: "12px"
    },

    header: {
        background: "#2f3542",
        color: "#fff",
        padding: "6px",
        borderRadius: "6px",
        marginBottom: "10px"
    },

    card: {
        background: "#fff",
        padding: "15px",
        borderRadius: "15px",
        marginBottom: "10px"
    },

    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "10px"
    },

    row: {
        display: "flex",
        gap: "10px"
    },

    buttonRow: {
        marginTop: "10px"
    },
    tableWrapper: {
        width: "100%",
        overflowX: "auto"
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed"   // 🔥 IMPORTANT (fix alignment)
    },

    tableHeader: {
        background: "#57606f",
        color: "#fff"
    },

    //th: {
    //    backgroundColor: "#343a40",
    //    color: "#fff",
    //    fontSize: "12px",
    //    fontFamily: "Verdana",
    //    padding: "6px 8px",
    //    border: "1px solid #ccc",     // ✅ FULL GRID
    //    whiteSpace: "nowrap"
    //},
    td: {
        padding: "6px 8px",
        fontSize: "12px",
        fontFamily: "Verdana",
        border: "1px solid #ccc"     // ✅ FULL GRID
    },

    inputStyle: {
        "& .MuiOutlinedInput-root": {
            height: "34px"
        },

        "& .MuiInputBase-input": {
            fontFamily: "Verdana",
            fontSize: "12px",
            padding: "8px 10px"
        },

        "& .MuiInputLabel-root": {
            fontFamily: "Verdana",
            fontSize: "12px"
        },

        // 🔥 FIX DROPDOWN SPECIFIC
        "& .MuiSelect-select": {
            padding: "8px 10px !important",
            display: "flex",
            alignItems: "center"
        }
    },
    th: {
        backgroundColor: "#343a40",
        color: "#fff",
        fontSize: "12px",
        fontFamily: "Verdana",
        padding: "6px 8px",          // ✅ reduced height
        borderRight: "1px solid #ccc", // ✅ subtle divider (not white)
        whiteSpace: "nowrap",        // ✅ prevent wrapping
        lineHeight: "1.2"            // ✅ keeps height tight
    }
};

export default DailyService;